// OpenAI (ChatGPT) Ads measurement pixel — https://developers.openai.com/ads/measurement-pixel
// Pixel ID is created in OpenAI Ads Manager -> Conversions tab.
const PIXEL_ID = "J9754yST5S7FMZEVTskema";

const enabled = Boolean(PIXEL_ID);

if (enabled) {
    (function (w, d, s, u) {
        if (w.oaiq) return;
        var q = function () {
            q.q.push(arguments);
        };
        q.q = [];
        w.oaiq = q;
        var js = d.createElement(s);
        js.async = true;
        js.src = u;
        var f = d.getElementsByTagName(s)[0];
        f.parentNode.insertBefore(js, f);
    })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

    window.oaiq("init", {
        pixelId: PIXEL_ID,
    });
}

function measure() {
    if (!enabled) return;
    window.oaiq.apply(null, ["measure"].concat(Array.prototype.slice.call(arguments)));
}

// OpenAI docs examples show amounts in minor units (2599 = 25.99); value arrives here in major units
function toMinorUnits(value) {
    return Math.round(Number(value) * 100);
}

function mapContents(products) {
    return products.map((product) => ({
        id: String(product.productId),
        name: product.name,
        content_type: "product",
        quantity: product.quantity || 1,
    }));
}

function oaiqPageView() {
    measure("page_viewed", { type: "contents" });
}

function oaiqAddToCart(product, currency, value) {
    measure("items_added", {
        type: "contents",
        amount: toMinorUnits(value),
        currency,
        contents: mapContents([product]),
    });
}

function oaiqBeginCheckout(products, currency, value) {
    measure("checkout_started", {
        type: "contents",
        amount: toMinorUnits(value),
        currency,
        contents: mapContents(products),
    });
}

function oaiqPurchaseComplete(products, currency, value, paymentIntent) {
    measure(
        "order_created",
        {
            type: "contents",
            amount: toMinorUnits(value),
            currency,
            contents: mapContents(products),
        },
        { event_id: paymentIntent }
    );
}

function oaiqSignUp() {
    measure("registration_completed", { type: "customer_action" });
}

export default {
    oaiqPageView,
    oaiqAddToCart,
    oaiqBeginCheckout,
    oaiqPurchaseComplete,
    oaiqSignUp,
};
